// @flow

/** @jsx h */

import MaxViewportObservable from '@nrk/max-viewport-observable'
import { Component, h } from 'preact'

type Props = {
  height?: string,
  onViewportChange: (viewport: any) => void
}

export default class MaxViewportRect extends Component<Props> {
  dispose: () => void
  elm: HTMLDivElement
  viewport$: any

  componentDidMount () {
    this.viewport$ = MaxViewportObservable.create({
      root: this.elm
    })

    this.dispose = this.viewport$.subscribe({
      next: (viewport) => {
        this.props.onViewportChange(viewport)
      }
    })
  }

  componentWillUnmount () {
    this.dispose()
  }

  render () {
    const height = this.props.height || 100
    const inlineStyle = { height: `${height}vh`, position: 'absolute' }
    return <div ref={elm => (this.elm = elm)} style={inlineStyle} />
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/MaxViewportRect.js